<template>
  <div class="flex flex-col h-full">
    <div class="border-0 border-b border-gray-200 border-solid">
      <HeaderWrapper
        ref="header-wrapper"
        :show-footer="false"
        :show-filter="false"
        :show-field="true"
      >
        <template #header>
          <div class="p-6 py-5">
            <div
              class="font-bold truncate flex items-center w-full"
              style="font-size: 17px"
            >
              Корректировка
            </div>
          </div>
        </template>
        <template #field> </template>
      </HeaderWrapper>
    </div>
    <main class="p-6 flex-1 min-h-0 flex flex-col overflow-hidden">
      <div class="flex-1 min-h-0">
        <el-table :data="oovData" v-loading="loading" border height="100%">
          <el-table-column
            prop="annotator"
            label="Аннотатор"
            width="120"
          ></el-table-column>
          <el-table-column
            prop="batch_id"
            label="ID строки"
            width="90"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="word"
            label="OOV"
            width="120"
          ></el-table-column>
          <el-table-column label="Текст" min-width="800">
            <template #default="{ row }">
              <el-input
                v-model="row.text"
                class="correction-text-input"
                @input="filterInput(row)"
                @contextmenu="handleRightClick($event, row)"
              />
            </template>
          </el-table-column>

          <el-table-column
            label="Действия"
            width="200"
            align="center"
            fixed="right"
          >
            <template #default="{ row }">
              <div class="flex justify-center w-full">
                <el-button type="info" plain @click="toggleAudio(row)">
                  <component
                    :is="row.isPlaying ? 'AudioPlaying' : 'PlayAudio'"
                    style="height: 14px; width: 14px"
                  />
                </el-button>
                <el-button type="primary" plain @click="saveText(row)">
                  <svg
                    viewBox="0 0 24 24"
                    style="height: 14px; width: 14px"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5 13l4 4L19 7"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      fill="none"
                    />
                  </svg>
                </el-button>
                <el-button type="danger" plain @click="deleteRow(row)">
                  <TrashIcon style="height: 14px; width: 14px; fill: none" />
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="flex justify-center mt-4 flex-shrink-0">
        <el-pagination
          v-if="total > limit"
          background
          layout="prev, pager, next"
          :page-size="limit"
          :current-page="page"
          :total="total"
          @current-change="handlePageChange"
        />
      </div>
    </main>

    <el-popover
      ref="selectionPopover"
      v-model:visible="popoverVisible"
      :virtual-ref="virtualRef"
      virtual-triggering
      width="220"
      placement="bottom"
      popper-class="m-0 mt-2.5 p-0"
    >
      <div class="flex flex-col items-center w-full">
        <div
          @click="addToDictionary('kz')"
          class="flex justify-center w-full p-2 rounded border border-solid border-transparent cursor-pointer hover:bg-gray-100 hover:border-gray-200"
        >
          Добавить в словарь kaz
        </div>
        <div
          @click="addToDictionary('ru')"
          class="flex justify-center w-full p-2 rounded border border-solid border-transparent cursor-pointer hover:bg-gray-100 hover:border-gray-200"
        >
          Добавить в словарь rus
        </div>
        <div
          @click="copySelectedText"
          class="flex w-full p-2 px-4 rounded border border-solid border-transparent cursor-pointer hover:bg-gray-100 hover:border-gray-200"
        >
          Скопировать текст
        </div>
      </div>
    </el-popover>
  </div>
</template>

<script>
import {
  fetchCorrectionData,
  saveCorrection,
  deleteCorrectionRow,
} from "@/api/correction";
import { addWordToDictionary, getDictionaryResult } from "@/api/dictionary";
import PlayAudio from "@/icons/PlayAudio.vue";
import AudioPlaying from "@/icons/AudioPlaying.vue";
import TrashIcon from "@/icons/TrashIcon.vue";
import { ElMessageBox, ElMessage } from "element-plus";
import HeaderWrapper from "@/components/HeaderWrapper.vue";

export default {
  name: "Correction",
  components: { HeaderWrapper, PlayAudio, AudioPlaying, TrashIcon },
  data() {
    return {
      oovData: [],
      page: 1,
      limit: 15,
      total: 0,
      loading: false,
      audioContext: null,
      currentSource: null,
      currentRow: null,
      popoverVisible: false,
      virtualRef: null,
      selectedText: "",
    };
  },
  computed: {
    domain() {
      return window.domain;
    },
    user() {
      return this.$store.state.user.user;
    },
  },
  mounted() {
    const scopes = this.user.scopes;
    if (!scopes.includes("admin") && !scopes.includes("verifier")) {
      this.$router.replace({ name: "Home" });
      return;
    }
    this.audioContext = new (window.AudioContext ||
      window.webkitAudioContext)();
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.loading = true;
      try {
        const res = await fetchCorrectionData(this.page, this.limit);
        if (res._success) {
          this.oovData = res.data.map((row) => ({ ...row, isPlaying: false }));
          this.total = res.total;
        }
      } catch (err) {
        console.error("Ошибка загрузки данных:", err);
      } finally {
        this.loading = false;
      }
    },
    handlePageChange(newPage) {
      this.page = newPage;
      this.fetchData();
    },
    async toggleAudio(row) {
      if (this.currentRow && this.currentRow !== row) {
        this.stopAudio(this.currentRow);
      }

      if (row.isPlaying) {
        this.stopAudio(row);
        return;
      }

      try {
        const audioUrl = this.domain + row.correction_data.path;
        const start = parseFloat(row.correction_data.start);
        const stop = parseFloat(row.correction_data.stop);

        const response = await fetch(audioUrl);
        const arrayBuffer = await response.arrayBuffer();
        const audioBuffer = await this.audioContext.decodeAudioData(
          arrayBuffer
        );

        const source = this.audioContext.createBufferSource();
        source.buffer = audioBuffer;
        source.connect(this.audioContext.destination);

        const duration = stop - start;
        source.start(0, start, duration);

        row.isPlaying = true;
        this.currentSource = source;
        this.currentRow = row;

        source.onended = () => {
          row.isPlaying = false;
          this.currentSource = null;
          this.currentRow = null;
        };
      } catch (err) {
        console.error("Ошибка воспроизведения аудио:", err);
        this.$message.error("Не удалось воспроизвести аудио");
      }
    },
    stopAudio(row) {
      if (this.currentSource) {
        this.currentSource.stop();
        if (row) row.isPlaying = false;
        this.currentSource = null;
        this.currentRow = null;
      }
    },
    async saveText(row) {
      this.loading = true;
      try {
        await saveCorrection(row.batch_id, row.text);
      } catch (err) {
        console.error("Ошибка сохранения:", err);
        this.$message.error("Ошибка при сохранении");
      } finally {
        this.loading = false;
      }
    },
    createVirtualRef(x, y) {
      return {
        getBoundingClientRect() {
          return { width: 0, height: 0, top: y, bottom: y, left: x, right: x };
        },
      };
    },
    handleRightClick(event) {
      event.preventDefault();

      const inputEl =
        event.target.closest(".el-input")?.querySelector("input") ||
        event.target;
      const start = inputEl.selectionStart;
      const end = inputEl.selectionEnd;
      const selectedText = inputEl.value.substring(start, end).trim();

      if (!selectedText) {
        this.popoverVisible = false;
        return;
      }

      this.selectedText = selectedText;
      const { clientX: x, clientY: y } = event;
      this.virtualRef = this.createVirtualRef(x, y);
      this.popoverVisible = true;
    },
    async addToDictionary(lang) {
      if (!this.selectedText) return;

      const normalizedSelected = this.selectedText.replace(/\s+/g, " ").trim();
      const payload = { text: normalizedSelected, lang };

      try {
        const response = await getDictionaryResult(payload);
        const alreadyExists = response?.success_words?.some(
          (item) => item.text.replace(/\s+/g, " ").trim() === normalizedSelected
        );
        const languageLabel = lang === "ru" ? "rus" : "kaz";

        if (alreadyExists) {
          ElMessage({
            message: `Слово "${normalizedSelected}" уже есть в словаре ${languageLabel}`,
            type: "warning",
            duration: 3000,
          });
        } else {
          await addWordToDictionary(payload);
        }
      } catch (error) {
        console.error(error);
        ElMessage.error("Ошибка при проверке словаря");
      } finally {
        this.popoverVisible = false;
      }
    },
    filterInput(row) {
      const validationSymbols =
        /^[АӘБВГҒДЕЁЖЗИЙКҚЛМНҢОӨПРСТУҮҰФХҺЦЧШЩЪЫІЬЭЮЯаәбвгғдеёжзийкқлмнңоөпрстуүұфхһцчшщъыіьэюя\s\-.*?+]*$/u;

      row.text = row.text
        .split("")
        .filter((char) => validationSymbols.test(char))
        .join("");
    },
    copySelectedText() {
      if (!this.selectedText) return;

      navigator.clipboard
        .writeText(this.selectedText)
        .then(() => {
          ElMessage({
            message: `Текст "${this.selectedText}" скопирован`,
            type: "success",
            duration: 2000,
          });
        })
        .catch((err) => {
          console.error("Ошибка копирования:", err);
          ElMessage.error("Не удалось скопировать текст");
        })
        .finally(() => {
          this.popoverVisible = false;
        });
    },
    async deleteRow(row) {
      await ElMessageBox.confirm(
        "Вы уверены, что хотите удалить?",
        "Подтверждение",
        {
          confirmButtonText: "Да",
          cancelButtonText: "Отмена",
          type: "error",
        }
      );
      this.loading = true;
      try {
        const res = await deleteCorrectionRow(row.batch_id);
        if (res._success) {
          await this.fetchData();
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
::v-deep(.el-table__header th.el-table__cell) {
  @apply bg-gray-50 text-gray-600;
}
::v-deep(.correction-text-input .el-input__inner) {
  color: #000000;
  font-size: 15px;
}
</style>
